module.exports = __webpack_public_path__ + "img/home_swiper_01_mobile.84749819.jpg";